/**
 * Product Image Hover Zoom
 */

(function () {
  const ZOOM_SCALE = 2.5;
  const ZOOM_STYLE_ID = 'qbs-product-hover-zoom-style';
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (!canHover) return;

  function bindZoom(img) {
    if (!img || img.dataset.zoomBound) return;

    img.style.display = 'block';
    img.style.willChange = 'transform';
    img.style.cursor = 'crosshair';
    img.style.transition = 'transform 0.16s ease-out';
    img.dataset.zoomBound = 'true';

    img.addEventListener('mousemove', onMouseMove);
    img.addEventListener('mouseleave', onMouseLeave);
  }

  function unbindZoom(img) {
    if (!img) return;
    img.removeEventListener('mousemove', onMouseMove);
    img.removeEventListener('mouseleave', onMouseLeave);
    img.style.transform = '';
    img.style.transformOrigin = '';
    img.style.transition = '';
    img.style.cursor = '';
    img.style.willChange = '';
    delete img.dataset.zoomBound;
  }

  function onMouseMove(e) {
    const img = e.currentTarget;
    const rect = img.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
    img.style.transform = `scale(${ZOOM_SCALE})`;
  }

  function onMouseLeave(e) {
    const img = e.currentTarget;
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
  }

  function getActiveImg() {
    return document.querySelector('.product__slider .product__slide.swiper-slide-active img');
  }

  function fixOverflow() {
    if (document.getElementById(ZOOM_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = ZOOM_STYLE_ID;
    style.textContent = `
      .product__slide { overflow: hidden; }
      .product__slide.swiper-slide-active { overflow: hidden !important; z-index: 10; }
      .product__slider { overflow: hidden; }
    `;
    document.head.appendChild(style);
  }

  function init() {
    if (window.__qbsProductHoverZoomInitialized) return;
    window.__qbsProductHoverZoomInitialized = true;

    fixOverflow();

    const img = getActiveImg();
    if (img) bindZoom(img);

    const wrapper = document.querySelector('.product__slider .swiper-wrapper');
    if (!wrapper) return;

    const observer = new MutationObserver(() => {
      document.querySelectorAll('.product__slide img[data-zoom-bound]').forEach(unbindZoom);
      const activeImg = getActiveImg();
      if (activeImg) bindZoom(activeImg);
    });

    observer.observe(wrapper, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  }

  function waitForSwiper() {
    if (document.querySelector('.product__slider .product__slide.swiper-slide-active')) {
      init();
      return;
    }

    const observer = new MutationObserver((_, obs) => {
      if (document.querySelector('.product__slider .product__slide.swiper-slide-active')) {
        obs.disconnect();
        init();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSwiper);
  } else {
    waitForSwiper();
  }
})();
